import React, { useEffect, useState } from 'react';
import { Button, Select, MenuItem, Grid } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { observer } from 'mobx-react';
import { useStores } from '../../../../../../../stores/Main';
import TournamentService from '../../../../../../../services/main/Tournament.service';
import Status from '../../../../../../../models/pages/tournament/Status';
import TournamentStatus from '../../../../../../../models/pages/tournament/TournamentStatus';
import schema from '../helpers/ValidationSchema';
import useStyles from './Modal.style';
import Toasters from '../../../../../../../components/popUp/PopUp';
import Loader from '../../../../../../../components/loader/Loader';
import { EmptyVoidFunction } from '../../../../../../../utils/types/Types';
import useTranslation from '../../../../../../../components/localization/customHooks/Translation';

const EditTournamentStatusModal = observer((props: { handleClose?: EmptyVoidFunction }) => {
  const { handleClose } = props;
  const l10n = useTranslation();
  const url = useParams<{ id: string }>();
  const id = Number(url.id);
  const { TournamentStore } = useStores();
  const { tournament } = TournamentStore;
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(true);
  const [allStatus, setAllStatus] = useState<Array<Status> | null>([]);

  const {
    control,
    handleSubmit,
    formState: { isDirty, isValid },
  } = useForm({
    mode: 'all',
    resolver: yupResolver(schema),
  });

  const getStatuses = async () => {
    const response = await TournamentService.getStatuses();
    setAllStatus(response.filter((element: Status) => element.status !== 3));
    setIsLoading(false);
  };

  useEffect(() => {
    getStatuses();
  }, []);

  const sendEditRequest = async (data: TournamentStatus) => {
    const result = { ...data };
    result.tournamentId = id;
    setIsLoading(true);
    const response = await TournamentService.updateStatus(result);

    if (response) {
      Toasters.success(l10n.components.toasterMessage.STATUS_HAS_BEEN_CHANGED);
      TournamentStore.getTournament(id);
    }

    setIsLoading(false);
    if (handleClose) {
      handleClose();
    }
  };

  return (
    <Grid className={classes.modalContent}>
      {isLoading ? (
        <Loader />
      ) : (
        <form className={classes.flex} onSubmit={handleSubmit(sendEditRequest)}>
          {allStatus && allStatus.length && (
            <Controller
              render={({ field }) => (
                <Select
                  {...field}
                  autoFocus
                  variant="outlined"
                  className={classes.margin}
                  value={field.value}
                  onChange={(e) => {
                    field.onChange(e);
                    e.stopPropagation();
                  }}
                >
                  {allStatus.map((el) => (
                    <MenuItem key={el.status} value={el.status}>
                      {el.description}
                    </MenuItem>
                  ))}
                </Select>
              )}
              name="status"
              control={control}
              defaultValue={tournament?.status}
            />
          )}
          <Button
            variant="contained"
            color="primary"
            className={classes.margin}
            type="submit"
            disabled={!isDirty || !isValid}
          >
            {l10n.components.button.CHANGE}
          </Button>
        </form>
      )}
    </Grid>
  );
});

export default EditTournamentStatusModal;
